import {Component, OnInit} from '@angular/core';
import {WelfareResultService} from '../../../../core/service/welfare-result.service';
import {Debt} from '../../../../core/class/debt';
import {HomeAsset} from '../../../../core/class/home-asset';
import {Asset} from '../../../../core/class/asset';
import {OtherAsset} from '../../../../core/class/other-asset';
import {Util} from '../../../../core/util/util';

@Component({
  selector: 'app-inserimento-dati',
  templateUrl: './inserimento-dati.component.html',
  styleUrls: ['./inserimento-dati.component.css']
})
export class InserimentoDatiComponent implements OnInit {

  selectedDebt = 0;
  selectedAsset = 0;

  constructor(private welfareService: WelfareResultService) {
  }

  ngOnInit() {
  }

  addDebt() {

    // create debt
    const debt = new Debt();

    switch (this.selectedDebt) {
      case 0: {
        debt.name = 'Mutuo';
      }
        break;

      case 1: {
        debt.name = 'Finanziamento';
      }
        break;

      case 2: {
        debt.name = 'Aseggno Figli';
      }
        break;
      case 3: {
        debt.name = 'Assegno Ex Coniuge';
      }
        break;
      case 4: {
        debt.name = 'Affitto';
      }
        break;
    }

    // add debt
    this.welfareService.addDebt(debt);
  }

  get familyMembers() {
    return this.welfareService.welfare.people;
  }

  get debts() {
    return this.welfareService.welfare.debts;
  }

  get assets() {
    return this.welfareService.welfare.assets;
  }

  addPerson() {
    this.welfareService.addPerson();
  }

  get welfare(){
    return this.welfareService;
  }

  addAsset() {

    let asset = null;

    switch (this.selectedAsset) {
      case 0: {
        asset = new HomeAsset();
      }
        break;
      case 1: {
        asset = new Asset();
      }
        break;

      case 2: {
        asset = new OtherAsset();
      }
        break;
    }

    this.welfareService.addAsset(asset);
  }

  isHomeAsset(asset: Asset): boolean {
    return Util.isHomeAsset(asset);
  }

  isOtherAsset(asset: Asset): boolean {
    return Util.isOtherAsset(asset);
  }

  isGeneralAsset(asset: Asset): boolean {
    return Util.isGeneralAsset(asset);
  }
}
